// ProtectedAdminRoute.tsx
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as authActions from "src/redux/slices/authAdminSlice";
import { getFromStorage } from "src/utils/storage";
import storageKeys from "src/constants/storage";
import Spinner from "../ui/Spinner";

interface ProtectedAdminRouteProps {
  children: React.ReactElement;
}

const ProtectedAdminRoute: React.FC<ProtectedAdminRouteProps> = ({
  children,
}) => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.authAdmin);

  const authAdminToken = getFromStorage(storageKeys.authAdminToken);
  // const userInfo = getFromStorage(storageKeys.userInfo);

  useEffect(() => {
    if (authAdminToken && !user?.data && !user?.error && !user?.loading) {
      dispatch(authActions.getUserDetailsRequest());
      // dispatch(authActions.setUser(JSON.parse(userInfo)));
    }
  }, [authAdminToken, dispatch, user]);

  if (!authAdminToken || (!user?.data && user?.error && !user?.loading)) {
    return <Navigate to="/admin/login" replace />;
  }

  if (user?.loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spinner />
      </div>
    );
  }

  return children;
};

export default ProtectedAdminRoute;
